import React from "react";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Fab,
  Chip,
  Button,
  TextField,
  Modal,
  ListItem,
  ListItemText,
  List,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from "@mui/material";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from "../layouts/Topbar";
import Sidebarr from "../layouts/Sidebar";
import Header from "../components/Header";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import AuthContext from "../auth/AuthProvider";
import Paper from "@mui/material/Paper";
import { api } from "../api";
import { fetchToken, fetchRole } from "../auth/Token";
import { FormatedDateAll } from "./AssociationPassbook";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  DataGrid,
  GridToolbar,
  GridActionsCellItem,
  GridRowParams,
} from "@mui/x-data-grid";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { Send } from "@mui/icons-material";
import { Cancel, ExpandMore, CheckCircle } from "@mui/icons-material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Dialog from "@mui/material/Dialog";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from "@mui/icons-material/Send";
import { toast } from 'sonner';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: 'groove',
  border: '3px',
  borderColor:'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',
  minHeight:'50px',
  borderRadius:'10px'
}));

const MyAccount = () => {
  const [details, setDetails] = useState([]);
  const [transactionsDetails, setTransactionsDetails] = useState([]);
  const [fundsForm, setFundsForm] = useState();
  const [admin, setAdmin] = useState(null);
  const [ledger_details, setLedger_details] = useState([]);
  const [open_modal, setOpen_modal] = useState(false);


  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });


  function formatDateToYearMonthDay(date) {
    const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
    } else if (day === 2 || day === 22) {
    suffix = "nd";
    } else if (day === 3 || day === 23) {
    suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
}


  const fetchLedgers = () => {
    api
      .get("/account/every/ledger/account", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLedger_details(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchAccount = () => {
    api
      .get("/account/my_account", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setDetails(response.data?.Details);
        setTransactionsDetails(response.data?.Transactions);
        setAdmin(response.data?.admin);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAccount();
    fetchLedgers();
  }, []);

  // console.log(transactionsDetails);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 720,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const formik = useFormik({
    initialValues: {
      transaction_type_id: 1,
      amount: null,
      narration: "",
      ledger_id: null,
      date: "",
      society_id: null
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Enter amount to process"),
      transaction_type_id: Yup.number().required(
        "Please select a transaction type"
      ),
    }),
    onSubmit: (values) => {
      const data = new FormData();
      data.append("transaction_type_id", values.transaction_type_id);
      data.append("amount", values.amount);
      data.append("narration", values.narration);
      data.append("date", values.date);
      data.append("ledger_id", values.ledger_id ? values.ledger_id : 0);
      data.append("society_id", values.society_id);

      api
        .post("/account/transact_funds", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik.handleReset();
          setFundsForm();
          setOpen_modal(false);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          fetchAccount();
        });
    },
  });

  const handleOpenModal = () => {
    if (formik.values.transaction_type_id == 1) {
      setOpen_modal(true);
    } else {
      formik.handleSubmit();
    }
  };
  const handleCancel = () => {
    formik.handleReset();
    // setFundsForm()
    fetchAccount();
  };

  const columns = [
    {
      field: "request_date",
      headerName: "Request Date",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) => formatDateToYearMonthDay(new Date(params.row.request_date)),
    },
    {
      field: "disburse_date",
      headerName: "Disbursed Date",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) =>
        params.row.disburse_date ? formatDateToYearMonthDay(new Date(params.row.disburse_date)) : (
          "Not yet disbursed"
        ),
    },
    {
      field: "narration",
      headerName: "Narration",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "debit",
      headerName: "Debit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.transaction_type_id === 2 ? currencyFormat.format(params.row.amount) : 0,
      editable: true,
    },
    {
      field: "credit",
      headerName: "Credit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.transaction_type_id === 1 ? currencyFormat.format(params.row.amount) : 0,
      editable: true,
    },
    {
      field: "balance",
      headerName: "Account Balance",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "recommended_amount",
      headerName: "Recommended amount",
      flex: 1,
      width: 70,
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
      width: 70,
    },
    {
      field: "transaction_type_id",
      headerName: "Type",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "amount",
      headerName: "Amount(GH₵)",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.status === "Request" ? (
          <Chip variant="outlined" color="primary" label="Pending Request" />
        ) : params.row.status === "Approved" ? (
          <Chip variant="outlined" color="secondary" label="Approved" />
        ) : params.row.status === "Disbursed" ? (
          <Chip variant="outlined" color="success" label="Disbursed" />
        ) : params.row.status === "Withdrawal" ? (
          <Chip variant="outlined" color="error" label="Withdrawal" />
        ) : (
          <Chip variant="outlined" color="error" label="Rejected" />
        ),
    },
    {
      field: "action",
      headerName: "Edit",
      width: 20,
      renderCell: (params) => (
        <>
          <IconButton
            disabled={
              params.row.status === "Request" || params.row.status === "Rejected"? false : true
            }
            onClick={() =>
              handleSeeMessage(
                params.row.message,
                params.row.amount,
                params.row.narration,
                params.row.transaction_id
              )
            }
          >
            <ViewStreamIcon />
          </IconButton>
        </>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 20,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleDelete(params.row.transaction_id)}>
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const handleDelete = (id) => {
    api
      .delete(`/account/request/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchAccount();
      });
  };

  const [note, setNote] = useState(false);
  const [amountt, setAmountt] = useState();
  const [naration, setNaration] = useState("");
  const [see, setSee] = useState(true);
  const [idd, setIdd] = useState();
  const [actionMessage, setActionMessage] = useState("");

  const handleSeeMessage = (message, amount, narration, transaction_id) => {
    setIdd(transaction_id);
    setAmountt(amount);
    setNaration(narration);
    setActionMessage(message);
    setNote(true);
    setSee(false);
  };
  const [ole, setOle] = useState(false);

  const handleClosse = () => {
    setNote(false);
    setAmountt();
    setNaration();
    setActionMessage();
  };

  const handelSetMessage = (event) => {
    event.preventDefault();
    const data = new FormData();
    data.append("transaction_id", idd);
    data.append("amount", amountt);
    data.append("actionMessage", actionMessage);
    data.append("narration", naration);
    api
      .post("/account/request/approve/use", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success("Edited");
        setNote(false);
        setAmountt();
        setNaration();
        setActionMessage();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchAccount();
      });
  };

  return (
    <div className="app">
      <div className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="My Account" subtitle="My Account Details" />
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Item>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      <FormLabel id="demo-row-radio-buttons-group-label">
                        Transaction Type
                      </FormLabel>
                      <RadioGroup
                        columns
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="transaction_type_id"
                        value={formik.values.transaction_type_id}
                        onChange={formik.handleChange}
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio />}
                          label="Request"
                        />
                        <FormControlLabel
                          disabled={details.current_balance <= 0 ? true : false}
                          value={2}
                          control={<Radio />}
                          label="Withdraw"
                        />
                        <FormControlLabel
                          disabled
                          value={3}
                          control={<Radio />}
                          label="Transfer"
                        />
                      </RadioGroup>
                      <FormHelperText>
                        {formik.errors.transaction_type_id}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                          required
                          size="small"
                          label="Amount"
                          variant="standard"
                          name="amount"
                          sx={{ mb: 2 }}
                          value={formik.values.amount}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.amount && Boolean(formik.errors.amount)
                          }
                          helperText={formik.touched.amount && formik.errors.amount}
                          type="number"
                          fullWidth
                        />

                        <TextField
                          required
                          size="small"
                          label="Reason for your request"
                          variant="outlined"
                          name="narration"
                          sx={{ mb: 2 }}
                          value={formik.values.narration}
                          onChange={formik.handleChange}
                          type="text"
                          multiline
                          rows={4}
                          fullWidth
                        />
                        {
                          admin == 1?
                          <TextField
                            size="small"
                            helperText="Request date"
                            variant="outlined"
                            name="date"
                            sx={{ mb: 2 }}
                            value={formik.values.date}
                            onChange={formik.handleChange}
                            type='datetime-local'
                            fullWidth
                          />
                          :null
                        }
                    </Grid>
                    <Grid item xs={12} md={12} sx={{ display:'flex', justifyContent:'flex-end' }}>
                      <Button
                        variant="outlined"
                        onClick={handleCancel}
                        sx={{ mt: 1, ml: 1 }}
                        size="small"
                        color="error"
                        endIcon={<Cancel />}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={handleOpenModal}
                        sx={{ mt: 1, ml: 1 }}
                        size="small"
                        color="success"
                        endIcon={<Send />}
                        disabled={
                          formik.values.transaction_type_id === 2 &&
                          formik.values.amount > details.current_balance
                            ? true
                            : false
                        }
                      >
                        Confirm
                      </Button>
                    </Grid>
                  </Grid>
              </Item>
            </Grid>
            <Grid item xs={12} md={12}>
              <Item>
                <Typography sx={{textAlign:'center', my:3}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5">
                  <b>Current Balance: {currencyFormat.format(details.current_balance)}</b>
                </Typography>

                <DataGrid
                  rows={transactionsDetails}
                  columns={columns}
                  autoHeight
                  checkboxSelection
                  getRowId={(row) => row.transaction_id}
                  slots={{ toolbar: GridToolbar }}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        transaction_id: false,
                        amount: false,
                        transaction_type_id: false,
                      },
                    },
                  }}
                />
              </Item>
            </Grid>
          </Grid>
        </Box>
        <Modal
          open={open_modal}
          onClose={() => setOpen_modal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            {ledger_details.map((item) => (
              <>
                <Accordion sx={{ mb: 1, borderRadius: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h5"
                      sx={{ color: "black" }}
                    >
                      <b>{item.society}</b>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                    >
                      {item.ledgers.map((ledg) => (
                        <>
                          <ListItem
                            alignItems="flex-start"
                            secondaryAction={
                              <IconButton
                                onClick={() =>{
                                  formik.setFieldValue("ledger_id", ledg.id)
                                  formik.setFieldValue("society_id", item.society_id)
                                }}
                                edge="end"
                                aria-label="comments"
                              >
                                <CheckCircle
                                  color={
                                    ledg.id === formik.values.ledger_id
                                      ? "success"
                                      : "primary"
                                  }
                                />
                              </IconButton>
                            }
                          >
                            {/* <ListItemAvatar>
                                                  <Avatar alt="aggregator" src={pic(item.picture_img)} />
                                                </ListItemAvatar> */}
                            <ListItemText
                              primary={ledg.account_name}
                              secondary={
                                <Box sx={{ display: "block" }}>
                                  <div>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.primary"
                                    >
                                      <b>{ledg.description}</b>
                                    </Typography>
                                  </div>
                                </Box>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                <Divider sx={{ m: 1 }} />
              </>
            ))}
            <Box sx={{ display: "flex" }}>
              <Button
                size="small"
                sx={{ m: "1px" }}
                onClick={() => setOpen_modal(false)}
                color="error"
                variant="contained"
              >
                Close
              </Button>
              <Button
                size="small"
                sx={{ m: "1px" }}
                onClick={formik.handleSubmit}
                color="success"
                variant="contained"
              >
                Request
              </Button>
            </Box>
          </Box>
        </Modal>
        <Dialog open={note} onClose={handleClosse}>
          <form onSubmit={handelSetMessage}>
            <DialogTitle>Edit Request</DialogTitle>
            <DialogActions
              sx={{ display: "flex", justifyContent: "space-around" }}
            >
              <Typography variant="h5">Edit Request</Typography>
              <label class="switch">
                <input
                  type="checkbox"
                  id="ole"
                  name="ole"
                  value={ole}
                  checked={ole}
                  onChange={(e) => setOle(e.target.checked)}
                />
                <span class="slider"></span>
              </label>
            </DialogActions>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    autoFocus
                    margin="dense"
                    disabled={ole === false ? true : false}
                    id="amountt"
                    name="amountt"
                    label="Requested Amount(GHS)"
                    type="text"
                    onChange={(e) => setAmountt(e.target.value)}
                    value={amountt}
                    fullWidth
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    autoFocus
                    margin="dense"
                    disabled={ole === false ? true : false}
                    id="naration"
                    name="naration"
                    label="Reason for funds"
                    onChange={(e) => setNaration(e.target.value)}
                    value={naration}
                    type="text"
                    fullWidth
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <TextField
                autoFocus
                required
                disabled
                margin="dense"
                id="actionMessage"
                name="actionMessage"
                label="Message for Action"
                type="text"
                fullWidth
                sx={{ marginBottom: 2 }}
                variant="outlined"
                multiline
                rows={4}
                value={actionMessage}
                onChange={(e) => setActionMessage(e.target.value)}
              />
            </DialogContent>
            <DialogActions
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Button onClick={handleClosse} variant="contained" color="error">
                Cancel
              </Button>
              <Fab
                disabled={ole === false ? true : false}
                component="button"
                type="submit"
                color="success"
                size="medium"
                aria-label="add"
              >
                <SendIcon />
              </Fab>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    </div>
  );
};

export default MyAccount;
